import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? "en").slice(0, 2);

  return (
    <div className="flex items-center gap-0.5 rounded-md border border-olive-600 p-0.5">
      {LANGUAGES.map((lng) => (
        <button
          key={lng}
          onClick={() => i18n.changeLanguage(lng)}
          className={
            "rounded px-1.5 py-0.5 text-xs font-semibold uppercase transition " +
            (current === lng
              ? "bg-gold text-olive-900"
              : "text-sand-muted hover:text-sand")
          }
          aria-pressed={current === lng}
        >
          {lng}
        </button>
      ))}
    </div>
  );
}
